/**
 * localPForwardsApi — RTK Query slice cho /purchase/local-p-forwards/*.
 * Tag type: 'LocalPForward'. Đồng thời invalidate 'LocalPVer2' (tổng hợp top-up alert).
 */
import { baseApi } from './baseApi'
import type {
  DataResponse,
  LocalPForwardCreateIn,
  LocalPForwardListQuery,
  LocalPForwardOut,
  LocalPForwardUpdateIn,
  MessageResponse,
  PageResponse,
} from '@/types/api'

export const localPForwardsApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listForwards: b.query<PageResponse<LocalPForwardOut>, LocalPForwardListQuery | void>({
      query: (params) => ({
        url: '/purchase/local-p-forwards/list',
        params: params ?? {},
      }),
      providesTags: (res, _e, arg) => {
        const contractNo = (arg && (arg as LocalPForwardListQuery).contract_no) || 'ALL'
        const list = res
          ? [
              ...res.items.map((f) => ({ type: 'LocalPForward' as const, id: f.id })),
              { type: 'LocalPForward' as const, id: `LIST-${contractNo}` },
            ]
          : [{ type: 'LocalPForward' as const, id: `LIST-${contractNo}` }]
        return [...list, { type: 'LocalPForward' as const, id: 'LIST' }]
      },
    }),
    createForward: b.mutation<DataResponse<LocalPForwardOut>, LocalPForwardCreateIn>({
      query: (body) => ({
        url: '/purchase/local-p-forwards/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: [
        { type: 'LocalPForward', id: 'LIST' },
        { type: 'LocalPVer2', id: 'LIST' },
      ],
    }),
    updateForward: b.mutation<
      DataResponse<LocalPForwardOut>,
      { forwardId: number; body: LocalPForwardUpdateIn }
    >({
      query: ({ forwardId, body }) => ({
        url: `/purchase/local-p-forwards/${forwardId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_r, _e, arg) => [
        { type: 'LocalPForward', id: arg.forwardId },
        { type: 'LocalPForward', id: 'LIST' },
        { type: 'LocalPVer2', id: 'LIST' },
      ],
    }),
    deleteForward: b.mutation<MessageResponse, number>({
      query: (forwardId) => ({
        url: `/purchase/local-p-forwards/${forwardId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_r, _e, forwardId) => [
        { type: 'LocalPForward', id: forwardId },
        { type: 'LocalPForward', id: 'LIST' },
        { type: 'LocalPVer2', id: 'LIST' },
      ],
    }),
  }),
})

export const {
  useListForwardsQuery,
  useCreateForwardMutation,
  useUpdateForwardMutation,
  useDeleteForwardMutation,
} = localPForwardsApi
